// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container */
.GatePass_container__VkFp1 {
  min-height: calc(100% - 88px);
}

/* Top Header Section */
.GatePass_topHeader__37QGE {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px 0 24px 0;
  border-radius: 12px;
}

.GatePass_headerLeft__EH6uo {
  flex: 1 1;
}

.GatePass_mainTitle__foV7q {
  color: var(--Slate-800, #1e293b);
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px; /* 133.333% */
}

.GatePass_subtitle__AHc96 {
  color: var(--Slate-500, #64748b);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
}

/* kpi section css */

.GatePass_gridContainer__nLEaO {
  margin-bottom: 24px;
  display: grid;
  gap: 20px; /* spacing between items */
  grid-template-columns: repeat(4, 1fr);
}

.GatePass_gridItem__ffPmi {
  background-color: #ffffff;

  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  text-align: center;
  transition: transform 0.2s;
}

.GatePass_gridItem__ffPmi:hover {
  transform: translateY(-4px);
}

.GatePass_itemHead__6LwmQ {
  align-items: center;
  display: flex;
  padding: 24px;
  padding-bottom: 16px;
  justify-content: space-between;
}
.GatePass_itemHead__6LwmQ > p {
  font-family: 'Inter';
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  color: #4b5563;
}

.GatePass_itemHead__6LwmQ + div {
  padding: 24px;
  padding-top: 1px;
}
.GatePass_itemHead__6LwmQ + div > h2 {
  color: #1f2937;
  font-family: 'Inter';
  font-weight: 500;
  font-style: Medium;
  font-size: 30px;
  line-height: 38px;
  letter-spacing: 0%;
  text-align: start;
  margin: 0;
}

.GatePass_itemHead__6LwmQ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 12px;
}

.GatePass_gridItem__ffPmi h2 {
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

/* Main Content */
.GatePass_mainContent__t7vWd {
  background-color: white;
  border-radius: 12px;
  padding: 24px 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* Table Styles */
.GatePass_tableContainer__jnnmw {
  border-radius: 12px;
  overflow-x: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--Neutrals-200, #e2e8f0);
}

/* Action Button */
.GatePass_actionBtn__Qo6v8 {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background-color: transparent;
  color: #6b7280;
  padding: 4px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.GatePass_actionBtn__Qo6v8:hover {
  background-color: #d6dbe2;
  color: #374151;
}

.GatePass_actionBtn__Qo6v8:focus {
  outline: none;
}

/* Responsive */
@media (max-width: 768px) {
  .GatePass_topHeader__37QGE {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .GatePass_mainTitle__foV7q {
    font-size: 20px;
  }

  .GatePass_gridContainer__nLEaO {
    grid-template-columns: 1fr;
  }
}

.GatePass_filtersSection__JUZb2 {
  background-color: white;
  border-radius: 12px;
  padding: 24px 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-bottom: 24px;
}

.GatePass_filterHeading__\\+QwZQ {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 20px;
}

.GatePass_filterHeading__\\+QwZQ h5 {
  padding: 0;
  margin: 0;
  font-family: 'Inter';
  font-weight: 600;
  font-size: 16px;
  line-height: 30px;
  color: #1e293b;
}

.GatePass_inputSection__EfhlY {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}

.GatePass_inputSection__EfhlY > div {
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
}

.GatePass_selectInput__5Q5GC,
.GatePass_searchInput__4ALzR {
  width: 100%;
}

.GatePass_statusRowParent__k-Vj3 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
}

.GatePass_statusRow__jwQK3 {
  display: flex;
  align-items: center;
  gap: 16px;
}

.GatePass_statusRow__jwQK3 h5 {
  margin: 0;
  font-family: 'Inter';
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #1e293b;
}

.GatePass_statusOptions__iN5Kh {
  display: flex;
  gap: 24px;
}

.GatePass_actionsRow__ZtjFo {
  display: flex;
  justify-content: flex-start;
  gap: 12px;
  /* margin-top: 16px; */
}

.GatePass_resetBtn__tA-jF {
  height: 40px;
  padding: 0 16px;
  border-radius: 8px;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  color: #111827;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  gap: 8px;
  cursor: pointer;
  align-items: center;
}

.GatePass_applyBtn__wrl\\+N {
  height: 40px;
  padding: 0 16px;
  border-radius: 8px;
  background: #644ee5;
  color: #fff;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}


/* =========================================
   RESPONSIVE BREAKPOINTS
========================================= */

/* ----------- XL & Large Laptops (≤ 1280px) ----------- */
@media (max-width: 1280px) {
  .GatePass_inputSection__EfhlY {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* ----------- Tablets 768px – 1024px ----------- */
@media (max-width: 1024px) {
  .GatePass_topHeader__37QGE {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .GatePass_gridContainer__nLEaO {
    grid-template-columns: repeat(2, 1fr);
  }

  .GatePass_filtersSection__JUZb2 {
    padding: 24px 20px;
  }

  .GatePass_statusRowParent__k-Vj3 {
    flex-direction: column;
    gap: 20px;
  }

  .GatePass_actionsRow__ZtjFo {
    width: 100%;
    justify-content: flex-start;
  }

  .GatePass_statusRowParent__k-Vj3 {
    align-items: unset;
  }
}

/* ----------- Mobile Large (≤ 768px) ----------- */
@media (max-width: 768px) {
  .GatePass_mainTitle__foV7q {
    font-size: 20px;
  }

  .GatePass_subtitle__AHc96 {
    font-size: 13px;
  }

  .GatePass_inputSection__EfhlY {
    grid-template-columns: 1fr;
  }

  .GatePass_statusOptions__iN5Kh {
    flex-wrap: wrap;
    gap: 12px;
  }
  .GatePass_statusRowParent__k-Vj3 {
    align-items: center;
  }
  .GatePass_actionsRow__ZtjFo {
    flex-wrap: wrap;
    width: 100%;
  }

  .GatePass_resetBtn__tA-jF,
  .GatePass_applyBtn__wrl\\+N {
    flex: 1 1;
    justify-content: center;
  }
}

@media (max-width: 580px) {
  .GatePass_container__VkFp1 {
    margin-left: 8px;
    margin-right: 8px;
  }
}

/* ----------- Mobile Small (≤ 480px) ----------- */
@media (max-width: 480px) {
  .GatePass_filtersSection__JUZb2 {
    padding: 16px;
  }

  .GatePass_itemHead__6LwmQ {
    padding: 16px;
    margin-bottom: 0;
    padding: 14px;
  }
  .GatePass_itemHead__6LwmQ > p {
    margin: 0;
    text-align: start;
  }
  .GatePass_itemHead__6LwmQ + div {
    padding: 0 14px 14px;
  }

  .GatePass_itemHead__6LwmQ + div h2 {
    font-size: 24px;
  }
  .GatePass_gridContainer__nLEaO {
    gap: 10px;
  }
  .GatePass_resetBtn__tA-jF,
  .GatePass_applyBtn__wrl\\+N {
    height: 38px;
    padding: 0 12px;
    font-size: 13px;
    flex: unset;
  }

  .GatePass_statusRowParent__k-Vj3 {
    align-items: flex-start;
  }

  .GatePass_statusRow__jwQK3 {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }

  .GatePass_actionsRow__ZtjFo {
    flex-direction: column;
    width: 100%;
    gap: 10px;
  }
}

/* Date Picker & Update Gate Pass Button */
.GatePass_datePickerContainer__xdnIV {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.GatePass_dateButton__m8vxY {
  appearance: none;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #0f172a;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 12px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  line-height: 1;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
  transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
  height: 44px;
  cursor: pointer;
}

.GatePass_dateButton__m8vxY:hover {
  border-color: #cbd5f5;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.12);
}

.GatePass_dateButton__m8vxY:focus-visible {
  outline: 2px solid #6366f1;
  outline-offset: 2px;
}

.GatePass_calendarIcon__KYsuM {
  width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
}

.GatePass_calendarIcon__KYsuM svg path {
  stroke: #94a3b8;
}

.GatePass_datePickerPopover__bXPtj {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 20;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 8px;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.18);
}

.GatePass_customCalendar__8CP3N {
  border: none !important;
  font-family: Inter, system-ui, sans-serif;
}

.GatePass_customCalendar__8CP3N .react-datepicker__header {
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
}

.GatePass_customCalendar__8CP3N .react-datepicker__day {
  margin: 2px;
  border-radius: 8px;
}

.GatePass_customCalendar__8CP3N .react-datepicker__day--selected {
  background-color: #644EE5 !important;
  color: #fff !important;
}

.GatePass_customCalendar__8CP3N .react-datepicker__day--today {
  border: 1px solid #644EE5;
}

.GatePass_customCalendar__8CP3N .react-datepicker__navigation {
  top: 2px;
}

.GatePass_customCalendar__8CP3N .react-datepicker__navigation-icon::before {
  border-color: #475569;
  border-style: solid;
}

.GatePass_updateGatePassBtn__PASOx {
  background-color: #644EE5 !important;
  color: white !important;
  text-transform: none !important;
  font-weight: 600 !important;
  padding: 0 22px !important;
  border-radius: 8px !important;
  font-family: Inter, sans-serif !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  white-space: nowrap !important;
  height: 44px !important;
  min-width: 170px !important;
  line-height: 1 !important;
}

.GatePass_updateGatePassBtn__PASOx:hover {
  background-color: rgb(76, 58, 168) !important;
}

.GatePass_gpExtensionBtn__3rqGi {
  background-color: #644EE5 !important;
  color: white !important;
  text-transform: none !important;
  font-weight: 600 !important;
  padding: 0 22px !important;
  border-radius: 8px !important;
  font-family: Inter, sans-serif !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  white-space: nowrap !important;
  height: 44px !important;
  min-width: 150px !important;
  line-height: 1 !important;
}

.GatePass_gpExtensionBtn__3rqGi:hover {
  background-color: rgb(76, 58, 168) !important;
}

.GatePass_spin__k\\+SOV {
  animation: GatePass_spin__k\\+SOV 1s linear infinite;
}

@keyframes GatePass_spin__k\\+SOV {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Expand custom upload toast to content width */
.Toastify__toast.uploadToast {
  width: auto !important;
  max-width: 95vw !important;
  padding: 0 !important;
}

.Toastify__toast.uploadToast .Toastify__toast-body {
  padding: 0 !important;
  margin: 15px !important;
}

/* Scope toast container styles only to upload results toasts on this page */
.uploadToastContainer.Toastify__toast-container {
  color: #fff;
  width: 785px;
  margin: 15px;
}

/* Scope close button style only for this component's toast container */
.uploadToastContainer .Toastify__close-button--light {
  color: #000;
  opacity: 0.3;
  margin-top: 14px;
  margin-right: 15px;
}


`, "",{"version":3,"sources":["webpack://./src/views/SuperMostAdmin/GatePass/GatePass.module.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,6BAA6B;AAC/B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA,oBAAoB;;AAEpB;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS,EAAE,0BAA0B;EACrC,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;;EAEzB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,oBAAoB;EACpB,8BAA8B;AAChC;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,8CAA8C;AAChD;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;;AAGA;;2CAE2C;;AAE3C,0DAA0D;AAC1D;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,mDAAmD;AACnD;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,mDAAmD;AACnD;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,SAAS;EACX;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;;IAEE,SAAO;IACP,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA,mDAAmD;AACnD;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,SAAS;IACT,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;;IAEE,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,SAAS;EACX;AACF;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,4CAA4C;EAC5C,iFAAiF;EACjF,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,+BAA+B;EAC/B,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;EAC7B,yCAAyC;EACzC,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,+BAA+B;EAC/B,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;EAC7B,yCAAyC;EACzC,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,mDAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,gDAAgD;AAChD;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,4EAA4E;AAC5E;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA,uEAAuE;AACvE;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["/* Container */\n.container {\n  min-height: calc(100% - 88px);\n}\n\n/* Top Header Section */\n.topHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 20px 0 24px 0;\n  border-radius: 12px;\n}\n\n.headerLeft {\n  flex: 1;\n}\n\n.mainTitle {\n  color: var(--Slate-800, #1e293b);\n  font-family: Inter;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 32px; /* 133.333% */\n}\n\n.subtitle {\n  color: var(--Slate-500, #64748b);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n}\n\n/* kpi section css */\n\n.gridContainer {\n  margin-bottom: 24px;\n  display: grid;\n  gap: 20px; /* spacing between items */\n  grid-template-columns: repeat(4, 1fr);\n}\n\n.gridItem {\n  background-color: #ffffff;\n\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  text-align: center;\n  transition: transform 0.2s;\n}\n\n.gridItem:hover {\n  transform: translateY(-4px);\n}\n\n.itemHead {\n  align-items: center;\n  display: flex;\n  padding: 24px;\n  padding-bottom: 16px;\n  justify-content: space-between;\n}\n.itemHead > p {\n  font-family: 'Inter';\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0%;\n  color: #4b5563;\n}\n\n.itemHead + div {\n  padding: 24px;\n  padding-top: 1px;\n}\n.itemHead + div > h2 {\n  color: #1f2937;\n  font-family: 'Inter';\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 30px;\n  line-height: 38px;\n  letter-spacing: 0%;\n  text-align: start;\n  margin: 0;\n}\n\n.itemHead {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 12px;\n}\n\n.gridItem h2 {\n  font-size: 20px;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n/* Main Content */\n.mainContent {\n  background-color: white;\n  border-radius: 12px;\n  padding: 24px 32px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n/* Table Styles */\n.tableContainer {\n  border-radius: 12px;\n  overflow-x: auto;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid var(--Neutrals-200, #e2e8f0);\n}\n\n/* Action Button */\n.actionBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background-color: transparent;\n  color: #6b7280;\n  padding: 4px;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: all 0.3s ease;\n}\n\n.actionBtn:hover {\n  background-color: #d6dbe2;\n  color: #374151;\n}\n\n.actionBtn:focus {\n  outline: none;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .topHeader {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n  .mainTitle {\n    font-size: 20px;\n  }\n\n  .gridContainer {\n    grid-template-columns: 1fr;\n  }\n}\n\n.filtersSection {\n  background-color: white;\n  border-radius: 12px;\n  padding: 24px 32px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  margin-bottom: 24px;\n}\n\n.filterHeading {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.filterHeading h5 {\n  padding: 0;\n  margin: 0;\n  font-family: 'Inter';\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 30px;\n  color: #1e293b;\n}\n\n.inputSection {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.inputSection > div {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  position: relative;\n}\n\n.selectInput,\n.searchInput {\n  width: 100%;\n}\n\n.statusRowParent {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 16px;\n}\n\n.statusRow {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.statusRow h5 {\n  margin: 0;\n  font-family: 'Inter';\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n  color: #1e293b;\n}\n\n.statusOptions {\n  display: flex;\n  gap: 24px;\n}\n\n.actionsRow {\n  display: flex;\n  justify-content: flex-start;\n  gap: 12px;\n  /* margin-top: 16px; */\n}\n\n.resetBtn {\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 8px;\n  background: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  color: #111827;\n  font-size: 14px;\n  font-weight: 500;\n  display: flex;\n  gap: 8px;\n  cursor: pointer;\n  align-items: center;\n}\n\n.applyBtn {\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 8px;\n  background: #644ee5;\n  color: #fff;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n\n/* =========================================\n   RESPONSIVE BREAKPOINTS\n========================================= */\n\n/* ----------- XL & Large Laptops (≤ 1280px) ----------- */\n@media (max-width: 1280px) {\n  .inputSection {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* ----------- Tablets 768px – 1024px ----------- */\n@media (max-width: 1024px) {\n  .topHeader {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .gridContainer {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .filtersSection {\n    padding: 24px 20px;\n  }\n\n  .statusRowParent {\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .actionsRow {\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .statusRowParent {\n    align-items: unset;\n  }\n}\n\n/* ----------- Mobile Large (≤ 768px) ----------- */\n@media (max-width: 768px) {\n  .mainTitle {\n    font-size: 20px;\n  }\n\n  .subtitle {\n    font-size: 13px;\n  }\n\n  .inputSection {\n    grid-template-columns: 1fr;\n  }\n\n  .statusOptions {\n    flex-wrap: wrap;\n    gap: 12px;\n  }\n  .statusRowParent {\n    align-items: center;\n  }\n  .actionsRow {\n    flex-wrap: wrap;\n    width: 100%;\n  }\n\n  .resetBtn,\n  .applyBtn {\n    flex: 1;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 580px) {\n  .container {\n    margin-left: 8px;\n    margin-right: 8px;\n  }\n}\n\n/* ----------- Mobile Small (≤ 480px) ----------- */\n@media (max-width: 480px) {\n  .filtersSection {\n    padding: 16px;\n  }\n\n  .itemHead {\n    padding: 16px;\n    margin-bottom: 0;\n    padding: 14px;\n  }\n  .itemHead > p {\n    margin: 0;\n    text-align: start;\n  }\n  .itemHead + div {\n    padding: 0 14px 14px;\n  }\n\n  .itemHead + div h2 {\n    font-size: 24px;\n  }\n  .gridContainer {\n    gap: 10px;\n  }\n  .resetBtn,\n  .applyBtn {\n    height: 38px;\n    padding: 0 12px;\n    font-size: 13px;\n    flex: unset;\n  }\n\n  .statusRowParent {\n    align-items: flex-start;\n  }\n\n  .statusRow {\n    flex-direction: column;\n    gap: 8px;\n    align-items: flex-start;\n  }\n\n  .actionsRow {\n    flex-direction: column;\n    width: 100%;\n    gap: 10px;\n  }\n}\n\n/* Date Picker & Update Gate Pass Button */\n.datePickerContainer {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.dateButton {\n  appearance: none;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #0f172a;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 8px 12px;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  line-height: 1;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);\n  transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;\n  height: 44px;\n  cursor: pointer;\n}\n\n.dateButton:hover {\n  border-color: #cbd5f5;\n  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.12);\n}\n\n.dateButton:focus-visible {\n  outline: 2px solid #6366f1;\n  outline-offset: 2px;\n}\n\n.calendarIcon {\n  width: 18px;\n  height: 18px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #94a3b8;\n}\n\n.calendarIcon svg path {\n  stroke: #94a3b8;\n}\n\n.datePickerPopover {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  z-index: 20;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 8px;\n  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.18);\n}\n\n.customCalendar {\n  border: none !important;\n  font-family: Inter, system-ui, sans-serif;\n}\n\n.customCalendar :global(.react-datepicker__header) {\n  background: #fff;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.customCalendar :global(.react-datepicker__day) {\n  margin: 2px;\n  border-radius: 8px;\n}\n\n.customCalendar :global(.react-datepicker__day--selected) {\n  background-color: #644EE5 !important;\n  color: #fff !important;\n}\n\n.customCalendar :global(.react-datepicker__day--today) {\n  border: 1px solid #644EE5;\n}\n\n.customCalendar :global(.react-datepicker__navigation) {\n  top: 2px;\n}\n\n.customCalendar :global(.react-datepicker__navigation-icon::before) {\n  border-color: #475569;\n  border-style: solid;\n}\n\n.updateGatePassBtn {\n  background-color: #644EE5 !important;\n  color: white !important;\n  text-transform: none !important;\n  font-weight: 600 !important;\n  padding: 0 22px !important;\n  border-radius: 8px !important;\n  font-family: Inter, sans-serif !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 8px !important;\n  white-space: nowrap !important;\n  height: 44px !important;\n  min-width: 170px !important;\n  line-height: 1 !important;\n}\n\n.updateGatePassBtn:hover {\n  background-color: rgb(76, 58, 168) !important;\n}\n\n.gpExtensionBtn {\n  background-color: #644EE5 !important;\n  color: white !important;\n  text-transform: none !important;\n  font-weight: 600 !important;\n  padding: 0 22px !important;\n  border-radius: 8px !important;\n  font-family: Inter, sans-serif !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 8px !important;\n  white-space: nowrap !important;\n  height: 44px !important;\n  min-width: 150px !important;\n  line-height: 1 !important;\n}\n\n.gpExtensionBtn:hover {\n  background-color: rgb(76, 58, 168) !important;\n}\n\n.spin {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Expand custom upload toast to content width */\n:global(.Toastify__toast.uploadToast) {\n  width: auto !important;\n  max-width: 95vw !important;\n  padding: 0 !important;\n}\n\n:global(.Toastify__toast.uploadToast) :global(.Toastify__toast-body) {\n  padding: 0 !important;\n  margin: 15px !important;\n}\n\n/* Scope toast container styles only to upload results toasts on this page */\n:global(.uploadToastContainer.Toastify__toast-container) {\n  color: #fff;\n  width: 785px;\n  margin: 15px;\n}\n\n/* Scope close button style only for this component's toast container */\n:global(.uploadToastContainer .Toastify__close-button--light) {\n  color: #000;\n  opacity: 0.3;\n  margin-top: 14px;\n  margin-right: 15px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GatePass_container__VkFp1`,
	"topHeader": `GatePass_topHeader__37QGE`,
	"headerLeft": `GatePass_headerLeft__EH6uo`,
	"mainTitle": `GatePass_mainTitle__foV7q`,
	"subtitle": `GatePass_subtitle__AHc96`,
	"gridContainer": `GatePass_gridContainer__nLEaO`,
	"gridItem": `GatePass_gridItem__ffPmi`,
	"itemHead": `GatePass_itemHead__6LwmQ`,
	"mainContent": `GatePass_mainContent__t7vWd`,
	"tableContainer": `GatePass_tableContainer__jnnmw`,
	"actionBtn": `GatePass_actionBtn__Qo6v8`,
	"filtersSection": `GatePass_filtersSection__JUZb2`,
	"filterHeading": `GatePass_filterHeading__+QwZQ`,
	"inputSection": `GatePass_inputSection__EfhlY`,
	"selectInput": `GatePass_selectInput__5Q5GC`,
	"searchInput": `GatePass_searchInput__4ALzR`,
	"statusRowParent": `GatePass_statusRowParent__k-Vj3`,
	"statusRow": `GatePass_statusRow__jwQK3`,
	"statusOptions": `GatePass_statusOptions__iN5Kh`,
	"actionsRow": `GatePass_actionsRow__ZtjFo`,
	"resetBtn": `GatePass_resetBtn__tA-jF`,
	"applyBtn": `GatePass_applyBtn__wrl+N`,
	"datePickerContainer": `GatePass_datePickerContainer__xdnIV`,
	"dateButton": `GatePass_dateButton__m8vxY`,
	"calendarIcon": `GatePass_calendarIcon__KYsuM`,
	"datePickerPopover": `GatePass_datePickerPopover__bXPtj`,
	"customCalendar": `GatePass_customCalendar__8CP3N`,
	"updateGatePassBtn": `GatePass_updateGatePassBtn__PASOx`,
	"gpExtensionBtn": `GatePass_gpExtensionBtn__3rqGi`,
	"spin": `GatePass_spin__k+SOV`
};
export default ___CSS_LOADER_EXPORT___;
